import api from './api';

export interface ProviderStatus {
  is_secret: boolean;
  configured: boolean;
  preview: string;
  env_present: boolean;
}

export interface ModelsInfo {
  installed: string[];
  recommended: { name: string; note: string; installed: boolean }[];
  active: string;
  ollama_up: boolean;
}

export interface PullStatus {
  [name: string]: { status: string; percent: number; done: boolean; error: string | null };
}

class SettingsService {
  async getProviders(): Promise<{ status: Record<string, ProviderStatus>; available: string[] }> {
    return (await api.get('/settings/providers')).data;
  }
  async setProviders(settings: Record<string, string>): Promise<{ status: Record<string, ProviderStatus>; available: string[] }> {
    return (await api.put('/settings/providers', { settings })).data;
  }
  async deleteProvider(key: string): Promise<any> {
    return (await api.delete(`/settings/providers/${key}`)).data;
  }
  async getModels(): Promise<ModelsInfo> {
    return (await api.get('/settings/models')).data;
  }
  async pullModel(name: string): Promise<any> {
    return (await api.post('/settings/models/pull', { name })).data;
  }
  async pullStatus(): Promise<PullStatus> {
    return (await api.get('/settings/models/pull-status')).data;
  }
  async setActiveModel(name: string): Promise<any> {
    return (await api.put('/settings/models/active', { name })).data;
  }
}

export const settingsService = new SettingsService();
export default settingsService;
